<template>
    <PullContainer
        ref="pullContainerRef"
        :pullDownLoading="true"
        :pullDownLabel="true"
        @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container m_message_wrap" v-loading="loading">
                <div class="mobile_head">
                    <div class="mobile_head_user" @click="handleClickUser">
                        <img
                            :src="
                                userInfo.user && userInfo.user.avatar
                                    ? userInfo.user.avatar
                                    : 'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'
                            "
                            alt=""
                        />
                        <span v-text="userInfo && userInfo.user ? userInfo.user.name : ''"></span>
                    </div>
                    <div class="mobile_head_operate">
                        <span><i class="iconfont icon-shezhi" @click="handleClickAdminSet"></i></span>
                    </div>
                </div>
                <ul class="m_message_tab">
                    <li
                        v-for="item in tabList"
                        :key="item.state"
                        :class="{ active: item.state == tabActive }"
                        @click="handleClickTab(item)"
                    >
                        {{ item.name }}
                        {{
                            item.state == "disturb"
                                ? item.disturb_unread_count > 99
                                    ? "99+"
                                    : item.disturb_unread_count
                                : item.total_unread > 99
                                ? "99+"
                                : item.total_unread
                        }}
                    </li>
                </ul>
                <div class="mobile_container">
                    <ul>
                        <li
                            v-for="(item, index) in groupListContent"
                            :key="item.id"
                            class="message_list_item"
                            :class="{
                                message_list_item_notDisturb: item.state == 'disturb',
                            }"
                            @click="handleClickDetail(item)"
                        >
                            <div class="message_list_item_icon">
                                <img :src="item.icon_url" alt="" />
                                <!-- 有未读的优先展示未读的数，没有再展示免打扰的数 -->
                                <i
                                    class="count"
                                    :class="{ count_notDisturb: !item.unread_count && item.disturb_unread_count > 0 }"
                                    v-if="item.unread_count > 0 || item.disturb_unread_count > 0"
                                    >{{
                                        item.unread_count
                                            ? item.unread_count > 99
                                                ? "99+"
                                                : item.unread_count
                                            : item.disturb_unread_count > 99
                                            ? "99+"
                                            : item.disturb_unread_count
                                    }}</i
                                >
                            </div>
                            <div class="message_list_item_content">
                                <p>
                                    <span>{{ item.category_name }}</span
                                    ><span>{{ item.last_message_time_show }}</span>
                                </p>
                                <p>
                                    <span class="ellipsis">{{ item.last_message_title }}</span
                                    ><i class="iconfont icon-message-notification" v-if="(!item.unread_count && item.disturb_unread_count > 0)  || tabActive == 'disturb'"></i>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
            </div>
        </template>
    </PullContainer>
</template>
<script>
import { MessageGroupCounts } from "@/api";
import { mapState } from "vuex";
import { EventBus } from '@/utils/eventBus';
import PullContainer from "@/components/mComponents/PullContainer.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
export default {
    name: "Message",
    components: {
        PullContainer,
        FooterTabbar,
    },
    data() {
        return {
            loading: false,
            tabActive: "all",
            tabList: [
                {
                    state: "all",
                    name: "全部",
                    total_unread: 0,
                    data: [],
                },
                {
                    state: "unread",
                    name: "未读",
                    total_unread: 0,
                    data: [],
                },
                {
                    state: "disturb",
                    name: "免打扰",
                    total_unread: 0,
                    disturb_unread_count: 0,
                    data: [],
                },
                {
                    state: "later",
                    name: "稍后处理",
                    total_unread: 0,
                    data: [],
                },
            ],
            groupListContent: [],
            tabBarList: [
                {
                    icon: "icon-gongzuotai_weixuanzhong1",
                    activeIcon: "icon-gongzuotai_xuanzhong",
                    routerName: "mobileWorkBench",
                    title: "工作台",
                },
                {
                    icon: "icon-renwu_weixuanzhong",
                    activeIcon: "icon-renwu_xuanzhong",
                    routerName: "mobileTodo",
                    title: "待办",
                },
                {
                    icon: "icon-xiaoxi",
                    activeIcon: "icon-xiaoxi1",
                    routerName: "Message",
                    title: "消息",
                },
                {
                    icon: "icon-gengduogongneng_weixuanzhong",
                    activeIcon: "icon-gengduogongneng_xuanzhong",
                    routerName: "mobileAllFunctions",
                    title: "全部",
                },
            ],
            tabBarActive: 2,
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        EventBus.$on('messageUpdate', this.getMessageGroupCounts);
        this.getMessageGroupCounts();
    },
    mounted() {},
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.getMessageGroupCounts();
            }
        },
        handleClickUser() {},
        // tab切换
        handleClickTab({ state, data }) {
            this.loading = true;
            this.tabActive = state;
            this.groupListContent = data || [];
            this.category_name_en = data[0]?.category_name_en || "";
            this.loading = false;
        },
        // 后台设置
        handleClickAdminSet() {
            this.$router.push({
                name: "MessageAdminManagement",
                params: {
                    isPush: true,
                },
            });
        },
        // 查看详情
        handleClickDetail(item) {
            this.$router.push({
                name: "MMessageDetail",
                query: {
                    category_name_en: item.category_name_en,
                    group_type: this.tabActive,
                    count: item.disturb_unread_count || item.unread_count,
                },
            });
        },
        // 获取消息左侧分组和未读数
        getMessageGroupCounts() {
            this.loading = true;
            MessageGroupCounts()
                .then((res) => {
                    if (res.code === 200) {
                        const data = res.data;
                        this.tabList[0].data = data.all.data || [];
                        this.tabList[0].total_unread = data.all.total_unread || 0;
                        this.tabList[1].data = data.unread.data || [];
                        this.tabList[1].total_unread = data.unread.total_unread || 0;
                        this.tabList[2].data = data.disturb.data || [];
                        this.tabList[2].total_unread = data.disturb.total_unread || 0;
                        this.tabList[2].disturb_unread_count = data.disturb.disturb_unread_count || 0;
                        this.tabList[3].data = data.later.data || [];
                        this.tabList[3].total_unread = data.later.total_unread || 0;
                        this.groupListContent = this.tabList.find((item) => item.state === this.tabActive).data || [];
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
    beforeDestroy() {
        EventBus.$off('messageUpdate', this.getMessageGroupCounts);
    },
};
</script>

<style lang="scss" scoped>
.m_message_wrap {
    background-color: #ffffff;
}
.mobile_head {
    display: flex;
    width: 100%;
    background: #fff;
    height: 44px;
    padding: 10px 16px;
    box-sizing: border-box;
    justify-content: space-between;
    .mobile_head_user {
        font-size: 0;
        display: flex;
        align-items: center;
        img {
            width: 24px;
            min-width: 24px;
            height: 24px;
            border-radius: 50%;
        }
        span {
            flex: 1;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
            font-weight: bold;
            display: inline-block;
            margin-left: 8px;
        }
    }
    .mobile_head_operate {
        display: flex;
        gap: 12px;
        span {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            line-height: 24px;
            font-size: 0;
            text-align: center;
            &:active {
                background: rgba(0, 0, 0, 0.04);
            }
            i {
                vertical-align: middle;
                color: rgba(51, 51, 51, 1);
                font-size: 16px;
            }
        }
    }
}
.m_message_tab {
    display: flex;
    width: 100%;
    background: #fff;
    height: 56px;
    padding: 8px 16px;
    box-sizing: border-box;
    justify-content: space-between;
    li {
        flex: 1;
        height: 40px;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(102, 102, 102, 1);
        overflow: hidden;
        white-space: nowrap;

        &.active {
            background: rgba(41, 144, 255, 0.05);
            font-size: 14px;
            font-weight: 700;
            color: rgba(41, 144, 255, 1);
        }
    }
}
.mobile_container {
    background-color: #ffffff;
    ul {
        padding: 0 8px;
    }
    .message_list_item {
        padding: 6px 8px;
        border-radius: 4px;
        display: flex;
        gap: 8px;
        margin-bottom: 14px;
        background-color: #ffffff;
        cursor: pointer;

        .message_list_item_icon {
            width: 42px;
            height: 42px;
            position: relative;
            flex-shrink: 0;

            img {
                width: 42px;
                height: 42px;
            }

            .count {
                position: absolute;
                top: -1px;
                right: -1px;
                padding: 0 4px;
                min-width: 18px;
                height: 18px;
                line-height: 16px;
                text-align: center;
                border: 1px solid #ffffff;
                font-size: 10px;
                font-weight: 500;
                color: #ffffff;
                border-radius: 10px;
                background-color: rgba(228, 65, 68, 1);

                &.count_notDisturb {
                    background-color: rgba(191, 191, 191, 1);
                }
            }
        }

        .message_list_item_content {
            flex: 1;
            overflow: hidden;

            p:nth-child(1) {
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                span:nth-child(1) {
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }

                span:nth-child(2) {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(153, 153, 153, 1);
                }
            }

            p:nth-child(2) {
                margin-top: 2px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(102, 102, 102, 1);
                display: flex;
                justify-content: space-between;

                span {
                    flex: 1;
                }

                .iconfont {
                    color: rgba(153, 153, 153, 1);
                }
            }
        }

        &.active,
        &:active {
            background-color: rgba(41, 144, 255, 0.1);
        }
    }
}
</style>
